import React, { useEffect, useState } from 'react';
import config from '../coreFIles/config';
import toast, { Toaster } from 'react-hot-toast';
import Header from '../directives/header';
import Footer from '../directives/footer';
import Sidebar from '../directives/sidebar';
import CustomPagination from './CustomPagination';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {getAdlistAction, getTotalAdListAction, adDeleteAction, adBlockUnBlockAction, getCategoriesListAction, getChildCategoriesListAction, searchUsersByEmailAction } from '../Action/action'
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
const loginData = (!Cookies.get('loginSuccessBondiAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessBondiAdmin'));

const Adlist = () => {
    const [adList, setAdList] 						= useState([]);
	const [page, setPage] 							= useState(1);	
	const [totalPages, settotalPages] 				= useState(0);
	const [totalRecords, settotalRecords] 			= useState(0);
	const [pagingspinloader, setpagingspinloader] 	= useState(0);
	const [startIndex, setstartIndex] 				= useState(0);
	const [adtypeFilter, setadtypeFilter] 			= useState('all');
	const [filterspinloader, setfilterspinloader] 	= useState(0); 
	const [CategoriesList, setCategories]			= useState([]);
	const [ChildCategoriesList, setChildCategories]	= useState([]);
	const [titleFilter, settitleFilter]				= useState('');
	const [catFilter, setcatFilter]					= useState('');
	const [subcatFilter, setsubcatFilter]			= useState('');
	const [subCatList, setsubCatList]				= useState([]);
	const [userSearchInput, setUserSearchInput]		= useState('');
	const [userSearchResults, setUserSearchResults] = useState([]);
	const [selectedUser, setSelectedUser]			= useState(null);
	const [showUserDropdown, setShowUserDropdown]	= useState(false);
	
    useEffect(() => {
		  if (!loginData?.email) {
            window.location.href = `${config.baseUrl}login`
        }
        
        // Check for user_id in URL params
        const urlParams = new URLSearchParams(window.location.search);
        const userId = urlParams.get('user_id');
        const userEmail = urlParams.get('user_email');
        
        if (userId && userEmail) {
            // Set selected user from URL params
            const decodedEmail = decodeURIComponent(userEmail);
            const userFromUrl = { id: userId, email: decodedEmail };
            setSelectedUser(userFromUrl);
            setUserSearchInput(decodedEmail);
            setPage(1);
            setstartIndex(0);
            
            // Fetch data immediately with user filter
            if (loginData?.email) {
                // Fetch with user filter directly
                getTotalAdListAction({
                    title: '',
                    p_cat: '',
                    sub_cat: '',
                    adtype: 'all',
                    member_id: userId
                }).then((totalRes) => {
                    if (totalRes.success) {
                        settotalPages(totalRes.data);
                        settotalRecords(totalRes.totalRecords);
                    }
                });
                
                getAdlistAction({
                    title: '',
                    p_cat: '',
                    sub_cat: '',
                    adtype: 'all',
                    page: 0,
                    member_id: userId
                }).then((listRes) => {
                    if (listRes.success) {
                        setAdList(listRes.data);
                    }
                });
            }
        } else {
            // No URL params, fetch all data
            if (loginData?.email) {
                getTotalAdListAPI();
                getAdlist();
            }
        }
        
        categoriesList();
        childcategoriesList();
       
    }, [])
    
    useEffect(() => {
        // Fetch data when selectedUser changes (but not on initial mount with URL params)
        if (loginData?.email && selectedUser) {
            const urlParams = new URLSearchParams(window.location.search);
            const userId = urlParams.get('user_id');
            // Skip if this is from URL params (already handled in first useEffect)
            if (!userId || selectedUser.id !== userId) {
                getTotalAdListAPI();
                getAdlist();
            }
        }
    }, [selectedUser])
    
     
    const SetpcatFilter = async (e) => {
        setcatFilter(e.target.value);  
        let searchpCat = e.target.value; 
		if(searchpCat != null && searchpCat !=''){
			const result = ChildCategoriesList.filter(data => String(data.parent_id).includes(searchpCat)); 
			setsubCatList(result); 		
		}        
    }  	
   const SetSubcatFilter = async (e) => {
        setsubcatFilter(e.target.value);        
    } 
    
   const inputtitleFilterHandler = async (e) => {
        settitleFilter(e.target.value);        
    } 
    
    const inputadtypeFilterHandler = e => {
        const { name, value, id } = e.target        
        setadtypeFilter(value); 
    }

    const handleUserSearch = async (e) => {
        const value = e.target.value;
        setUserSearchInput(value);
        
        if (value.length >= 3) {
            try {
                let res = await searchUsersByEmailAction({ email: value });
                if (res.success && res.data) {
                    setUserSearchResults(res.data);
                    setShowUserDropdown(true);
                } else {
                    setUserSearchResults([]);
                    setShowUserDropdown(false);
                }
            } catch (error) {
                console.error('Error searching users:', error);
                setUserSearchResults([]);
                setShowUserDropdown(false);
            }
        } else {
            setUserSearchResults([]);
            setShowUserDropdown(false);
        }
    }

    const handleSelectUser = (user) => {
        setSelectedUser(user);
        setUserSearchInput(user.email);
        setUserSearchResults([]);
        setShowUserDropdown(false);
    }

    const handleClearUser = () => {
        setSelectedUser(null);
        setUserSearchInput('');
        setUserSearchResults([]);
        setShowUserDropdown(false);
    }
    
    const categoriesList = async () => {
		let res = await getCategoriesListAction();
		if (res.success) {
			let data = res.data;			
			setCategories(data);	
		}
		else
		{
			setCategories([]);	
		}
	}
	
	const childcategoriesList = async () => {
		let res = await getChildCategoriesListAction();
		if (res.success) {
			let data = res.data;			
			setChildCategories(data);	
		}
		else
		{
			setChildCategories([]);	
		}
	}
    
     const handleFilter = async () => {
	   if(adtypeFilter != 'all' || catFilter != '' || subcatFilter != '' || titleFilter != '' || (selectedUser != null && selectedUser.id))
	   {
		   setPage(1);
		   setstartIndex(0);
		   // Call API with page 1 directly
		   let totalRes = await getTotalAdListAction({
			   title: titleFilter,
			   p_cat: catFilter,
			   sub_cat: subcatFilter,
			   adtype: adtypeFilter,
			   member_id: selectedUser ? selectedUser.id : ''
		   });
		   if (totalRes.success) {
			   settotalPages(totalRes.data);
			   settotalRecords(totalRes.totalRecords);
		   }
		   
		   let listRes = await getAdlistAction({
			   title: titleFilter,
			   p_cat: catFilter,
			   sub_cat: subcatFilter,
			   adtype: adtypeFilter,
			   page: 0, // page 1 = offset 0
			   member_id: selectedUser ? selectedUser.id : ''
		   });
		   if (listRes.success) {
			   setAdList(listRes.data);
		   }
	   }
	   else
	   {
		   toast.error('Please select atleast one option.');
	   }
	};
    
    const getTotalAdListAPI = async () => {
        let res = await getTotalAdListAction({
            title: titleFilter,
            p_cat: catFilter,
            sub_cat: subcatFilter,
            adtype: adtypeFilter,
            member_id: selectedUser ? selectedUser.id : ''
        });
        if (res.success) {
            settotalPages(res.data);
            settotalRecords(res.totalRecords);
            setpagingspinloader(0);
		}
        else
        {
			settotalPages(0);
			settotalRecords(0);
			setpagingspinloader(0);
		}
    }
   
  	const getAdlist = async () => {
		let res = await getAdlistAction({
            title: titleFilter,
            p_cat: catFilter,
            sub_cat: subcatFilter,
            adtype: adtypeFilter,
            page: page,
            member_id: selectedUser ? selectedUser.id : ''
        });
		if (res.success) {
			let data = res.data;			
			setAdList(data);	
		}
		else
		{
			setAdList([]);	
		}
	}
      
  	const adDelete = async (id) => {
		Swal.fire({
			title: 'Are you sure? ',
			text: "You want to Delete this ad text!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
		}).then(async (result) => {
			if (result.isConfirmed) {
				let res = await adDeleteAction({'id':id});
				if (res.success) {
					toast.success(res.msg);
					getAdlist();
				} else {
					toast.error(res.msg);
				}
			}
		});
	}
	
 	const adBlockUnBlock = async (id, is_active) => {
        Swal.fire({
            title: 'Are you sure?',
            text: is_active == 0 ? "You want to deactivate this ad text!”" : "You want to activate this ad text!”",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: is_active == 0 ? 'Yes, deactivate it!' : 'Yes, activate it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
				let res = await adBlockUnBlockAction({ 'id': id, 'is_active': is_active });
				if (res.success) {
					getAdlist();
					Swal.fire(
						is_active == 0 ? 'Deactivate!' : 'Activate',
						res.msg,
						'success'
					)
				} else {
					Swal.fire(
						'Failed!',
						res.msg,
						'error'
					)
				}
			}
		})
	}
	 const SrNo = (index) => {
		return startIndex + index + 1;
	  };

	const onPageChanged = async (data)  => {
		const { currentPage, totalPages, pageLimit } = data;
		const offset = (currentPage - 1) * pageLimit;
		setstartIndex(offset);	
		let res = await getAdlistAction({
            title: titleFilter,
            p_cat: catFilter,
            sub_cat: subcatFilter,
            adtype: adtypeFilter,
            page: offset,
            member_id: selectedUser ? selectedUser.id : ''
        });
		if (res.success) {
			setAdList(res.data);
		}
		else
		{
			setAdList([]);
		}
	}
	
	function getDaysleft(todate){
		var oneDay = 24 * 60 * 60 * 1000;
		var currentDate = new Date();
		todate = new Date(todate);
		
		currentDate	= moment(currentDate).format('YYYY, MM, DD');
		todate	= moment(todate).format('YYYY, MM, DD');

		currentDate	= new Date(currentDate);
		todate	= new Date(todate);
		
		var days = Math.round(Math.abs((currentDate - todate) / oneDay));
		
		if(Date.parse(currentDate) < Date.parse(todate)){
			return days;
		}
		else{
			return '-';
		}
	}
	
	

    return (
		<>
			<div className="wrapper">
				<Toaster />
				<Header />
				<Sidebar />
				<div className="content-wrapper">
					<div className="container-full">
						{/* Main content */}
                        <div className="content-header">
                            <div className="d-flex align-items-center">
                                <div className="me-auto">
                                    <h3 className="page-title mb-3 mb-md-5 pb-2">Ad List</h3>
                                </div>
                            </div>
                            <hr />
                        </div>
						<section className="content">
							<div className="row">
								<div className="col-lg-12 col-12">
									<div className="box">
                                        <div className="box-header with-border">
                                            <div className="row mb-15 align-items-center">
                                                <h4 className="box-title col-md-6 col-sm-6 col-12 mb-2 mb-md-0">Ad List ({totalRecords})</h4>
                                                <div className="col-md-6 col-sm-6 col-12 text-md-right text-left">
                                                    <a href={`${config.baseUrl}ad-create`} className="btn btn-sm btn-primary add_btn"><i className='fa fa-plus'></i> Add New Ad</a>
                                                </div>
                                            </div>
                                              <div className="row">
                                               <div className="col-12 col-md-6 col-lg-2 mb-3">
												<input type="text" name='titleFilter' className="form-control lh25" id='titleFilter' onChange={inputtitleFilterHandler} value={titleFilter} placeholder="Title" />
                                             </div>
                                                  <div className="col-12 col-md-6 col-lg-2 mb-3">
												<select name='adtypeFilter' className="form-control lh25" id='adtypeFilter' onChange={inputadtypeFilterHandler} value={adtypeFilter}>
													<option value="all">Select ad type</option>
													 <option value="1">Free</option>
													 <option value="0">Paid</option>
													 <option value="IsDeleted">Unpublished Ads</option>
													 <option value="isspam">Spam</option>								
												</select>
                                             </div>
                                           <div className="col-12 col-md-6 col-lg-2 mb-3">
                                            <select className="form-control lh25" id="p_cat_id" name="p_cat_id" onChange={SetpcatFilter} value={catFilter}>
													  <option value="">Select Category</option>
													  {
														CategoriesList.map((item)=>{
															return(
																<option value={item.cat_id}>{item.cat_name}</option>
															)
														})
														}	
														</select>
											</div>
                                            <div className="col-12 col-md-6 col-lg-2 mb-3">
											<select className="form-control lh25" id="sub_cat_id" name="sub_cat_id" onChange={SetSubcatFilter} value={subcatFilter}>
														  <option value="">Select Sub category</option>					
															{
														subCatList.map((item,index)=>{
															return(
																<option value={item.cat_id}>{item.cat_name}</option>
															)
														})
													}						
														</select>
											</div>
                                            <div className="col-12 col-md-6 col-lg-2 mb-3" style={{ position: 'relative' }}>
												<input 
													type="text" 
													name="userSearch" 
													className="form-control lh25" 
													id="userSearch" 
													onChange={handleUserSearch} 
													onBlur={() => setTimeout(() => setShowUserDropdown(false), 200)}
													value={userSearchInput} 
													placeholder="Search User Email" 
												/>
												{showUserDropdown && userSearchResults.length > 0 && (
													<ul className="list-group" style={{ 
														position: 'absolute', 
														zIndex: 1000, 
														width: '100%', 
														backgroundColor: 'white',
														border: '1px solid #ccc',
														borderRadius: '4px',
														marginTop: '2px',
														boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
													}}>
														{userSearchResults.map((user, index) => (
															<li 
																key={user.id} 
																className="list-group-item" 
																style={{ cursor: 'pointer', padding: '8px 12px' }}
																onMouseDown={(e) => {
																	e.preventDefault();
																	handleSelectUser(user);
																}}
																onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
																onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
															>
																<div>
																	<strong>{user.email}</strong>
																	{user.fname || user.lname ? (
																		<div style={{ fontSize: '12px', color: '#666' }}>
																			{user.fname} {user.lname}
																		</div>
																	) : null}
																</div>
															</li>
														))}
													</ul>
												)}
												{selectedUser && (
													<button 
														type="button" 
														className="btn btn-sm btn-link" 
														onClick={handleClearUser}
														style={{ position: 'absolute', right: '5px', top: '5px', padding: '2px 5px' }}
													>
														<i className="fa fa-times"></i>
													</button>
												)}
											</div>
                                             <div className="col-12 col-md-6 col-lg-2 mb-3"> 
                                               <div className="d-flex flex-wrap gap-2">                                                 
                                                { filterspinloader == '0' ?
                                                      <>                                                      
                                                   <button className="btn btn-sm btn-primary add_btn" onClick={handleFilter}>Filter <i className="fa fa-filter" aria-hidden="true"></i></button>
                                                   </>
                                                   :
                                                    <>
                                                     <button disabled className="btn btn-sm btn-primary add_btn" >Geting... &nbsp; <i className="fa fa-spinner fa-spin validat"></i></button>
                                                      </>
                                                  } 
												   <button 
                                        className="btn btn-sm btn-primary add_btn" 
										onClick={async (e) => {
											e.preventDefault();
											settitleFilter('');
											setcatFilter('');
											setsubcatFilter('');
											setadtypeFilter('all');
											setSelectedUser(null);
											setUserSearchInput('');
											setUserSearchResults([]);
											setShowUserDropdown(false);
											setPage(1);
											setstartIndex(0);
											// Reset filters and fetch data
											let totalRes = await getTotalAdListAction({title:'',p_cat:'',sub_cat:'',adtype:'all',member_id:''});
											if (totalRes.success) {
												settotalPages(totalRes.data);
												settotalRecords(totalRes.totalRecords);
											}
											let listRes = await getAdlistAction({title:'',p_cat:'',sub_cat:'',adtype:'all',page:1,member_id:''});
											if (listRes.success) {
												setAdList(listRes.data);
											}
										}}>Clear <i className="fa fa-eraser" aria-hidden="true"></i></button> 
                                               </div>
                                       </div>                                 
                                        </div>
                                        
											
										</div>
										<div className="box-body">
                                            <div className="table-responsive" style={{ overflowX: 'auto' }}>
												<table className="table table-bordered">
													<thead>
														<tr>
                                                        <th>#</th>
                                                        <th>Name</th>
                                                        <th className="d-none d-lg-table-cell">Category</th>
                                                        <th className="d-none d-xl-table-cell">Plan Name</th>
                                                        <th className="d-none d-md-table-cell">Start Date</th>
                                                        <th className="d-none d-md-table-cell">End Date</th>
														<th>Action</th>
														</tr>
													</thead>
													<tbody>
													{adList.length > 0 ? (
														adList.map((item, index) => (
														<tr key={item.id}>
																<td>{SrNo(index)}</td>
															<td style={{ position: 'relative' }}>
																<span 
																	className={`badge ${item.plan_id === 0 ? 'badge-success' : 'badge-primary'}`}
																	style={{ 
																		display: 'inline-block',
																		position: 'absolute',
																		top: '2px',
																		left: '2px',
																		zIndex: 1
																	}}
																>
																	{item.plan_id === 0 ? 'Free' : 'Paid'}
																</span>
																{item.isspam === 1 && <span className='spam'>Spam</span>} 
                                                            &nbsp;&nbsp;  
															<Link to={`${config.baseUrl}edit-ad/${item.id}`} style={{ color: '#007bff', textDecoration: 'none', cursor: 'pointer' }} title={item.title || ''}>
																{(item.title || '').length > 40 ? (item.title || '').substring(0,40) + '...' : item.title || ''}
															</Link>
															</td>
                                                            <td className="d-none d-lg-table-cell">{item.category}</td>
                                                            <td className="d-none d-xl-table-cell" style={{ position: 'relative' }}>
                                                                {item.plan_id === 0 ? '-' : (
                                                                    <>
                                                                        {item.plan_name}
                                                                        {(() => {
                                                                            const daysLeft = getDaysleft(item.toDate);
                                                                            return daysLeft !== '-' && daysLeft > 0 ? (
                                                                                <span className="badge badge-info" style={{ position: 'absolute', top: '2px', left: '2px' }}>
                                                                                    {daysLeft} days left
                                                                                </span>
                                                                            ) : null;
                                                                        })()}
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td className="d-none d-md-table-cell">{item.plan_id === 0 ? '-' : moment(item.fromdate).format('DD/MM/YYYY') }</td>
                                                            <td className="d-none d-md-table-cell">{item.plan_id === 0 ? '-' : moment(item.toDate).format('DD/MM/YYYY') }</td>
															<td>   
                                                                <div className="d-flex flex-wrap mb-2" style={{ minWidth: '150px', gap: '4px' }}>
                                                                    {item.status === 0 ?
                                                                        <button type="button" className="waves-effect waves-light btn btn-danger btn-sm m-1" onClick={() => adBlockUnBlock(item.id, 1)}><i className='fa fa-unlock'></i> <span className="d-none d-sm-inline">Inactive</span></button>
                                                                        : item.status === 1 ?
                                                                            <button type="button" className="waves-effect waves-light btn btn-primary btn-sm m-1" onClick={() => adBlockUnBlock(item.id, 0)}><i className='fa fa-ban'></i> <span className="d-none d-sm-inline">Active</span></button>
                                                                            :
                                                                            null
                                                                    }
                                                                    <Link to={`${config.baseUrl}edit-ad/${item.id}`} className="m-1">
                                                                        <button className='btn-sm btn-primary'><i className='fa fa-pencil'></i> <span className="d-none d-sm-inline">Edit</span></button>
                                                                    </Link>
                                                                    <button type="button" className="waves-effect waves-light btn btn-danger btn-sm m-1" onClick={() => adDelete(item.id)}><i className='fa fa-trash'></i> <span className="d-none d-sm-inline">Delete</span></button>
                                                                </div>
															</td>
														</tr>
													))
												) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">No record found.</td>
													</tr>
												)}

												</tbody>
												</table>	
												{totalPages > 0 ?										  
												<CustomPagination totalRecords={totalRecords} totalPages={totalPages} pageNeighbours={page} onPageChanged={onPageChanged}   />
												: ''
											}	
																				
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>                       
					</div>
				</div>      	
				<Footer />
			</div>
		</>
    )

}
export default Adlist;
